import { useObjectContext } from '@context/ItemZoneContext'
import { ChangeEvent } from 'react'
import GroupWrapper from './GroupWrapper'
function debounce(func: VoidFunction, delay: number) {
  let timeoutId: NodeJS.Timeout

  return function () {
    clearTimeout(timeoutId)
    // abortController.abort('refetch')
    timeoutId = setTimeout(() => {
      func.apply(null)
    }, delay)
  }
}
function throttle(func: VoidFunction, delay: number) {
  let lastCalledTime = 0

  return function () {
    const now = Date.now()
    if (now - lastCalledTime >= delay) {
      func.apply(null)
      lastCalledTime = now
    }
  }
}
export function GroupSearch() {
  const {
    setSearchValue,
    actions: { refetchOnSearch },
  } = useObjectContext()

  const memo = debounce(refetchOnSearch, 500)
  async function handleChange(e: ChangeEvent<HTMLInputElement>) {
    const texto = (e.target as HTMLInputElement).value
    setSearchValue(texto)
    memo()

    return
  }
  return <GroupWrapper handleChange={handleChange} />
}
